import { format } from "date-fns";
import teams from "../../../utils/teams";
import IIndicationsRequest from "../types/IIndicationsRequest";

import productMapping from "./productMapping";

export default class TeamsMessage {
  public static async postIndication(record: IIndicationsRequest) {
    const records = record.indications
      .filter((r) => !!r.postToTeams)
      .map((indication) => {
        const chatId = productMapping[indication.product];

        let message = "";

        message += `<b>Product:</b> ${indication.product}<br />`;
        indication.prices.forEach((r) => {
          if (indication.priceType === "single") {
            message += `<b>Origin</b>: ${r.origin} | <b>Price</b>: $${r.fobPrice}<br />`;
          } else {
            message += `<b>Origin</b>: ${r.origin} | <b>Price</b>: $${r.fobMinPrice} - $${r.fobMaxPrice}<br />`;
          }
        });
        if (indication.quantity) {
          message += `<b>Qty</b>: ${indication.quantity}<br />`;
        }
        message += `<b>Contact:</b> ${record.contactName}<br />`;
        message += `<b>Account:</b> ${record.party}<br />`;
        message += `<b>Ship Window:</b> ${format(
          new Date((indication.startDate as string).replaceAll("-", "/")),
          "MMM yyyy"
        )} - ${format(
          new Date((indication.endDate as string).replaceAll("-", "/")),
          "MMM yyyy"
        )}<br />`;
        message += `<b>Mode:</b> ${indication.mode}<br />`;
        message += indication.comments;

        return { message, chatId };
      });

    await teams.getAccessToken(); // Need to fail if can't auth?

    // https://support.microsoft.com/en-us/office/use-markdown-formatting-in-microsoft-teams-4d10bd65-55e2-4b2d-a1f3-2bebdcd2c772

    //  Attachment or html options here
    // https://learn.microsoft.com/en-us/graph/api/chatmessage-post?view=graph-rest-1.0&tabs=http

    await Promise.all(
      records.map(async (r) => {
        await teams.sendChatMessage(r.chatId, r.message);
      })
    );
  }
}
